export default __webpack_public_path__ + "static/media/PINC.5b1160d4.png";